import React from 'react';
import { Paper, Typography, TextField, Button, Stack } from '@mui/material';

function Contact() {
  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Contact Us
      </Typography>
      <Stack spacing={2} component="form" autoComplete="off">
        <TextField label="Name" variant="outlined" required fullWidth />
        <TextField label="Email" variant="outlined" required fullWidth type="email" />
        <TextField label="Message" variant="outlined" required fullWidth multiline rows={4} />
        <Button variant="contained" color="primary" size="large" type="submit">
          Send Message
        </Button>
      </Stack>
    </Paper>
  );
}

export default Contact; 